import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Breadcrumb />

        <section className="w-full pt-4 pb-16 md:pb-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto mb-16">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-6">
                关于毒蘑菇测试
              </h1>
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-6">
                毒蘑菇测试是一个专注于毒蘑菇鉴别科普的公益平台。我们致力于为野外采摘爱好者、户外运动爱好者和食品安全关注者提供权威、科学、易懂的毒蘑菇鉴别知识。
              </p>
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-6">
                每年，中国因误食毒蘑菇导致的中毒事件数以千计，其中不乏致命案例。这些悲剧的发生，很大程度上是因为公众缺乏科学的毒蘑菇鉴别知识，轻信民间偏方和错误经验。我们希望通过系统化的科普内容，帮助更多人掌握正确的毒蘑菇测试方法，减少中毒事件的发生。
              </p>
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                我们的内容涵盖外观鉴别法、化学反应测试、孢子印测试等多种科学鉴别手段，同时提供常见毒蘑菇图鉴对比、中毒急救指南和野外采摘安全建议，力求为用户提供全方位的毒蘑菇安全知识。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-16">
              <div className="text-center p-6 md:p-8 bg-background-100 rounded-xl">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-shield-check-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  科学严谨
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有鉴别方法均基于真菌学研究成果，参考国内外权威文献和专家意见，确保信息准确可靠。
                </p>
              </div>
              <div className="text-center p-6 md:p-8 bg-background-100 rounded-xl">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-heart-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  公益初心
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们坚持公益定位，免费向公众提供毒蘑菇鉴别知识，让更多人远离蘑菇中毒风险。
                </p>
              </div>
              <div className="text-center p-6 md:p-8 bg-background-100 rounded-xl">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-user-star-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  易于理解
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  用通俗易懂的语言和丰富的图片对比，让没有任何专业知识的人也能学会毒蘑菇鉴别技巧。
                </p>
              </div>
            </div>

            <section className="mb-16 bg-background-100 rounded-2xl p-8 md:p-12">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6 text-center">
                  我们的声誉
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
                  <div>
                    <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">50万+</div>
                    <p className="text-sm text-foreground-600">累计服务用户</p>
                  </div>
                  <div>
                    <div className="text-3xl md:text-4xl font-heading font-bold text-accent-600 mb-2">200+</div>
                    <p className="text-sm text-foreground-600">毒蘑菇品种收录</p>
                  </div>
                  <div>
                    <div className="text-3xl md:text-4xl font-heading font-bold text-secondary-600 mb-2">30+</div>
                    <p className="text-sm text-foreground-600">真菌学专家合作</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-16">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  联系我们
                </h2>
                <div className="bg-background-100 rounded-2xl p-8 md:p-10">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                    <div>
                      <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4">
                        联系方式
                      </h3>
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                            <i className="ri-mail-line text-primary-600"></i>
                          </div>
                          <div>
                            <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                            <p className="text-sm text-foreground-800">contact@mushroomtest.cn</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                            <i className="ri-phone-line text-accent-600"></i>
                          </div>
                          <div>
                            <p className="text-xs text-foreground-500 mb-0.5">咨询电话</p>
                            <p className="text-sm text-foreground-800">400-123-4567</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                            <i className="ri-map-pin-line text-secondary-600"></i>
                          </div>
                          <div>
                            <p className="text-xs text-foreground-500 mb-0.5">办公地址</p>
                            <p className="text-sm text-foreground-800">北京市海淀区中关村科技园区</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4">
                        紧急情况
                      </h3>
                      <div className="bg-accent-50 border border-accent-200/70 rounded-xl p-5">
                        <div className="flex items-start gap-3">
                          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                            <i className="ri-alert-line text-accent-600"></i>
                          </div>
                          <div>
                            <p className="text-sm font-semibold text-accent-800 mb-1">
                              如怀疑蘑菇中毒
                            </p>
                            <p className="text-sm text-accent-700 leading-relaxed mb-2">
                              请立即拨打120急救电话或前往最近医院急诊科。保留剩余蘑菇样本供医生参考。
                            </p>
                            <p className="text-sm text-accent-700 font-medium">
                              全国中毒控制热线：可让医生拨打咨询
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                  免责声明
                </h2>
                <div className="bg-background-100 rounded-2xl p-8">
                  <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                    <p>
                      毒蘑菇测试（以下简称"本站"）提供的内容仅供科普教育和参考之用，不构成任何形式的医疗建议或诊断。
                    </p>
                    <p>
                      本站发布的蘑菇鉴别方法基于现有的真菌学研究成果，但不能保证100%准确。不同蘑菇种类之间存在变异，即使经验丰富的专家也可能出现判断失误。
                    </p>
                    <p>
                      野外采摘蘑菇存在固有风险。我们强烈建议：未经过专业训练的个人不要仅凭本站信息进行蘑菇采摘和食用。如怀疑误食毒蘑菇，请立即就医，切勿等待或自行处理。
                    </p>
                    <p>
                      本站不对因使用本站信息而导致的任何损失或伤害承担责任。使用本站信息即表示您已理解并接受以上声明。
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}